import React, { FC } from 'react'
import ProfileButton from './ProfileButton'
import NamePrefix from './NamePrefix'
// import TranslationButton from './TranslationButton'
interface HeaderProps {
    toggleNavbar: boolean
    setToggleNavbar: (toggle: boolean) => void
}

const HeaderMobile: FC<HeaderProps> = ({ toggleNavbar, setToggleNavbar }) => {
    return (
        <nav className="navbar msn-navbar sticky-top d-lg-none py-3">
            <div className="container-fluid">
                <div className="msn-nav-toggle" onClick={() => setToggleNavbar(!toggleNavbar)}>
                    <i className={"fal fa-bars " + (toggleNavbar ? '' : 'open')}></i>
                    <i className={"fal fa-times " + (toggleNavbar ? 'open' : '')}></i>
                </div>
                <NamePrefix className='name-prefix-mobile' />
                {/* <TranslationButton /> */}
                <ProfileButton />
            </div>
        </nav>
    )
}

export default HeaderMobile